module.exports = __webpack_public_path__ + "static/img/community25.bee29c4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/community25.png
// module id = eRpn
// module chunks = 0